import { ComponentProps } from 'react';

import SignPlaceholderIcon from '@/assets/icons/sign-placeholder.svg?url';
import { SIGNS } from '@/modules/SIGNS';

interface SignCodeIconProps extends ComponentProps<'img'> {
  code: string;
  deleted?: boolean;
}

export function SignCodeIcon({ code, deleted, style, ...props }: SignCodeIconProps) {
  if (code in SIGNS)
    return (
      <img
        src={SIGNS[code as keyof typeof SIGNS].url}
        alt={`Verkehrszeichen ${code}`}
        {...props}
        style={{ ...style, opacity: deleted ? 0.5 : 1 }}
      />
    );

  return <img src={SignPlaceholderIcon} alt={`Verkehrszeichen ${code}`} {...props} />;
}
